import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Radium from "radium";
import ListItem from "./listItem";
import ListItem2 from "./listitem2";
import { semanticColors, greyScaleColors } from "../../../../Globals/styles";
import {
  updateUsageAmount,
  updateUsageKind,
  getUsageSuggestions,
  setUsageAmountTouched,
  setUsageKindTouched,
  addEmptyUsage,
  addEmptyUsageSub,
  onSubChange,
  onSubRemove
} from "./actions";
import { isStringValid } from "../../../../Util/stringValidator";
import { httpGet } from "../../../../Util/http";

class Usage extends Component {

  constructor(props) {
    super(props)
    this.state = {
      workplaceProducts: []
    }
  }

  // shouldComponentUpdate = (nextProps) => {
  //   if (this.state.showRecent) {
  //     return true
  //   }
  //   return (
  //     nextProps.materiale !== this.props.materiale ||
  //     nextProps.materiel !== this.props.materiel ||
  //     nextProps.suggestions !== this.props.suggestions
  //   );
  // };
  isMaterielContainerActive = () => {
    const { materiel } = this.props;
    for (let i = 0; i < materiel.length; i++) {
      if (materiel[i].name) return true;
    }
    return false;
  };
  isMaterialeContainerActive = () => {
    const { materiale } = this.props;
    for (let i = 0; i < materiale.length; i++) {
      if (materiale[i].name) return true;
    }
    return false;
  };

  async componentDidMount() {
    var _url =
      process.env.REACT_APP_webApiEndPoint +
      `api/arbejdsmiljo/${this.props.workplaceId}/datasheets`;
    let products = await httpGet(_url)
      .then((resp) => resp.json())
      .then(products => {
        const list = []
        products.forEach(product => {
          let hide = false;
          const id = product.id
          this.props.materiale.concat(this.props.materiel).forEach(pr => {
            if (pr.id == id) {
              hide = true
            }
          })
          if (!hide) {
            list.push(product)
          }
        })
        return list
      })
      .catch((e) => {
        // mute
      });
    this.setState({
      workplaceProducts: products
    })
  }
  render() {
    const { materiel, materiale, dispatch, suggestions } = this.props;
    let isAllMaterielValid = true;
    let materielNodes = materiel.map((m, index) => {
      let isKindValid =
        !m.kindTouched ||
        (isStringValid(m.name) && m.id != null) ||
        !isStringValid(m.name);
      let isAmountValid = !m.amountTouched || m.amount > 0 || m.id == null;

      if (!isKindValid || !isAmountValid) isAllMaterielValid = false;

      let subs = []
      if (m.subs) {
        subs = m.subs.map((item, index2) => {
          return <ListItem2
            key={index2}
            item={item}
            placeholder={'serienummer'}
            index={index2 + 1}
            isKindValid={isKindValid}
            isAmountValid={isAmountValid}
            type="materiel"
            remove={() => {
              dispatch(onSubRemove("materiel", index, index2))
            }}
            onSubChange={(val) => {
              dispatch(onSubChange("materiel", index, index2, val))
            }}
            addEmptyUsage={() => {
              if (index2 === m.subs.length - 1)
                dispatch(addEmptyUsageSub("materiel", m.id, index));
            }}
            updateUsageAmount={() => { }}
            updateUsageKind={() => { }}
            getUsageSuggestions={() => { }}
            setUsageAmountTouched={() => { }}
            setUsageKindTouched={() => { }}
            suggestions={[]}
          ></ListItem2>
        })
      }
      return (
        <ListItem
          key={index}
          item={m}
          index={index}
          isKindValid={isKindValid}
          isAmountValid={isAmountValid}
          type="materiel"
          addSub={() => {
            dispatch(addEmptyUsageSub("materiel", m.id, index));
          }}
          updateUsageAmount={(amount) => {
            dispatch(updateUsageAmount("materiel", index, amount))
          }
          }
          updateUsageKind={(id, name, unit) => {
            const newWorkplaceProducts = []
            this.state.workplaceProducts.forEach(pr => {
              if (pr.id !== id) {
                newWorkplaceProducts.push(pr)
              }
            })
            this.setState({
              workplaceProducts: newWorkplaceProducts
            })
            return dispatch(updateUsageKind("materiel", index, id, name, unit))
          }}
          getUsageSuggestions={(val) => {
            return dispatch(getUsageSuggestions("materiel", val))
          }
          }
          setUsageAmountTouched={() =>
            dispatch(setUsageAmountTouched("materiel", index))
          }
          setUsageKindTouched={() => {
            return dispatch(setUsageKindTouched("materiel", index))
          }
          }
          addEmptyUsage={() => {
            if (index === materiel.length - 1) {
              dispatch(addEmptyUsage("materiel"));
            }
          }
          }
          suggestions={suggestions}
          recent={this.state.workplaceProducts}
        >
          {subs}
        </ListItem>
      );
    });

    let isAllMaterialeValid = true;

    let materialeNodes = materiale.map((m, index) => {
      let isKindValid =
        !m.kindTouched ||
        (isStringValid(m.name) && m.id != null) ||
        !isStringValid(m.name);
      let isAmountValid = !m.amountTouched || m.amount > 0 || m.id == null;
      if (!isKindValid || !isAmountValid) isAllMaterialeValid = false;

      let subs = []
      if (m.subs) {
        subs = m.subs.map((item, index2) => {
          return <ListItem2
            key={index2}
            placeholder={'batch'}
            item={item}
            index={index2 + 1}
            isKindValid={isKindValid}
            isAmountValid={isAmountValid}
            type="materiale"
            remove={() => {
              dispatch(onSubRemove("materiale", index, index2))
            }}
            onSubChange={(val) => {
              dispatch(onSubChange("materiale", index, index2, val))
            }}
            addEmptyUsage={() => {
              if (index2 === m.subs.length - 1)
                dispatch(addEmptyUsageSub("materiale", m.id, index));
            }}
            updateUsageAmount={() => { }}
            updateUsageKind={() => { }}
            getUsageSuggestions={() => { }}
            setUsageAmountTouched={() => { }}
            setUsageKindTouched={() => { }}
            suggestions={[]}
          ></ListItem2>
        })
      }


      return (
        <ListItem
          key={index}
          item={m}
          index={index}
          isKindValid={isKindValid}
          isAmountValid={isAmountValid}
          type="materiale"
          addSub={() => {
            dispatch(addEmptyUsageSub("materiale", m.id, index));
          }}
          updateUsageAmount={(amount) =>
            dispatch(updateUsageAmount("materiale", index, amount))
          }
          updateUsageKind={(
            id,
            name,
            unit,
            dataSheet,
            technicalDataSheet,
            chemDataSheet
          ) => {
            const newWorkplaceProducts = []
            this.state.workplaceProducts.forEach(pr => {
              if (pr.id !== id) {
                newWorkplaceProducts.push(pr)
              }
            })
            this.setState({
              workplaceProducts: newWorkplaceProducts
            })
            return dispatch(
              updateUsageKind(
                "materiale",
                index,
                id,
                name,
                unit,
                dataSheet,
                technicalDataSheet,
                chemDataSheet
              )
            )
          }

          }
          getUsageSuggestions={(val) =>
            dispatch(getUsageSuggestions("materiale", val))
          }
          setUsageAmountTouched={() =>
            dispatch(setUsageAmountTouched("materiale", index))
          }
          setUsageKindTouched={() =>
            dispatch(setUsageKindTouched("materiale", index))
          }
          addEmptyUsage={() => {
            if (index === materiale.length - 1)
              dispatch(addEmptyUsage("materiale"));
          }}
          suggestions={suggestions}
          recent={this.state.workplaceProducts}
        >
          {subs}
        </ListItem>
      );
    });

    return (
      <div>
        <div style={styles.outerContainer}>
          <div
            className="row"
            style={[
              styles.container,
              this.isMaterielContainerActive() && styles.containerActive,
              !isAllMaterielValid && styles.containerError,
            ]}
          >
            <div style={styles.heading}>Materiel/Maskiner</div>
            <div>
              <div
                style={[styles.colHeading, styles.firstColumn]}
                className="col-xs-8"
              >
                Art
              </div>
              <div style={styles.colHeading} className="col-xs-2">
                Antal
              </div>
              <div style={styles.colHeading} className="col-xs-1">
                Enhed
              </div>
              <div style={styles.colHeadingCenter} className="col-xs-1">
                S/N
              </div>
            </div>
            {materielNodes}
          </div>
        </div>
        <div style={styles.outerContainer}>
          <div
            className="row"
            style={[
              styles.container,
              this.isMaterialeContainerActive() && styles.containerActive,
              !isAllMaterialeValid && styles.containerError,
            ]}
          >
            <div style={styles.heading}>Materiale</div>
            <div>
              <div
                style={[styles.colHeading, styles.firstColumn]}
                className="col-xs-8"
              >
                Art
              </div>
              <div style={styles.colHeading} className="col-xs-2">
                Antal
              </div>
              <div style={styles.colHeading} className="col-xs-1">
                Enhed
              </div>
              <div style={styles.colHeadingCenter} className="col-xs-1">
                Batch
              </div>
            </div>
            {materialeNodes}
          </div>
        </div>
      </div>
    );
  }
}

var styles = {
  outerContainer: {
    margin: "0 0 12px 0",
    paddingRight: "12px",
  },
  container: {
    backgroundColor: greyScaleColors.greyLighter,
    padding: "2px 0 8px 6px",
    margin: "0",
    borderLeft: "2px solid " + semanticColors.mainBackground,
  },
  containerActive: {
    borderLeft: "2px solid " + semanticColors.info,
  },
  containerError: {
    borderLeft: "2px solid " + semanticColors.danger,
  },
  firstColumn: {
    paddingLeft: "0",
    textAlign: "left",
  },
  heading: {
    marginBottom: "5px",
  },
  colHeading: {
    fontSize: "12px",
    paddingBottom: "4px",
    textAlign: "right",
  },
  colHeadingCenter: {
    fontSize: "12px",
    paddingBottom: "4px",
    textAlign: "center",
  }
};

const selectProps = (state) => {
  return {
    ...state.dailyReportUsageReducer,
  };
};
Usage.propTypes = {
  materiel: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string.isRequired,
      unit: PropTypes.string,
      kindTouched: PropTypes.bool,
      amount: PropTypes.number,
      amountTouched: PropTypes.bool,
    })
  ),
  materiale: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string.isRequired,
      unit: PropTypes.string,
      kindTouched: PropTypes.bool,
      amount: PropTypes.number,
      amountTouched: PropTypes.bool,
    })
  ),
  dispatch: PropTypes.func.isRequired,
  suggestions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      unit: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
};
export default connect(selectProps)(Radium(Usage));



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Usage/index.jsx